interface QueryType {
    key: string;
    label: string;
}

interface SubCategory {
    key: string;
    label: string;
}

interface Integration {
    key: string;
    label: string;
    subCategories?: SubCategory[];
}

interface TransferAgentConfig {
    queryTypes: QueryType[];
    integrations: Integration[];
}

export const TRANSFER_AGENT_CONFIG: TransferAgentConfig = {
    queryTypes: [
        // { key: 'Integration Support', label: 'Integration Support' },
        { key: 'Technical Issues', label: 'Technical Issues' },
        { key: 'Payment Issues', label: 'Payment Issues' },
        { key: 'Filing Inquiries', label: 'Filing Inquiries' },
        // { key: 'Excel Import Help', label: 'Excel Import Help' },
        // { key: 'Rights Management', label: 'Rights Management' },
        { key: 'Other Assistance', label: 'Other Assistance' },
    ],
    integrations: [
        {
            key: 'QuickBooks Desktop',
            label: 'QuickBooks Desktop',
            subCategories: [
                { key: 'Plug-in', label: 'Plug-in' },
                { key: 'Two Report Method', label: 'Two Report Method' },
                { key: 'Web Apps 3.0', label: 'Web Apps 3.0' },
                { key: 'Web Connector', label: 'Web Connector' },
            ],
        },
        {
            key: 'QuickBooks Online',
            label: 'QuickBooks Online',
        },
        {
            key: 'Xero',
            label: 'Xero',
        },
        {
            key: 'Bill',
            label: 'Bill.com',
        },
        {
            key: 'Zoho Books',
            label: 'Zoho Books',
        },
        {
            key: 'Sage Intacct',
            label: 'Sage Intacct',
        },
        {
            key: 'Excel Import',
            label: 'Excel Import'
        },
        {
            key: 'Other',
            label: 'Other'
        }
    ],
};

export const DESCRIPTION_MSG = 'For faster response, provide the form type, tax year, and approximate form count.'